<template>
  <div class="m-products-view">
    <section class="m-products-hero">
      <img alt="产品" src="https://qiniu.shunmingelectronic.com/guanwang/product/productBanner.jpg"
        class="m-products-hero__bg">
      <div class="m-products-hero__overlay"></div>
      <div class="m-products-hero__content">
        <span class="km-eyebrow">OUR PRODUCTS</span>
        <h1 class="m-products-hero__title">我们的产品</h1>
      </div>
    </section>
    <div class="tabs">
      <div v-for="(product, index) in productInfo" :key="index" @click="selectTab(product.categoryId)" class="tab"
        :class="{ active: isActiveTab(product.categoryId) }">
        {{ product.categoryEnName }}</div>
    </div>
    <div class="tab-content">
      <FlowMeterProduct  v-if="activeTab===2"/>
      <IotProduct  v-if="activeTab===3"/>
      <LightingProduct v-if="activeTab===1"/>
      <FlowMeterDevice v-if="activeTab===4"/>
     <!-- <div v-if="activeTab===1">1</div>
     <div v-if="activeTab===2">2</div>
     <div v-if="activeTab===3">3</div> -->
    </div>
  </div>
</template>

<script>
import FlowMeterProduct from '../product/MobileFlowMeterProduct.vue';
import IotProduct from '../product/MobileIotProduct.vue';
import LightingProduct from '../product/MobileLightingProduct.vue';
import FlowMeterDevice from '../product/MobileFlowMeterDevice.vue';
export default {
  name: 'ProductsView',
  components:{
    FlowMeterProduct,IotProduct,LightingProduct,FlowMeterDevice
  },
  data() {
    return {
      activeTab: 1,
      productList: [],
      matchedProduct: null,
      productInfo:[]
    };
  },
  methods: {
    selectTab(index) {
      const matchedProduct = this.productInfo.find(product => product.categoryId === index);
      this.matchedProduct = matchedProduct;
      this.productList = matchedProduct.products;
      this.activeTab = index;
    },
    isActiveTab(index) {
      return this.activeTab === index;
    },
    jumpProductDetail(product) {
      let link = "/productsDetail";
      this.$router.push({ path: link, query: { productId: product.productId, productEnName: product.productEnName, categoryId: this.matchedProduct.categoryId, categoryEnName: this.matchedProduct.categoryEnName } });
    },
    handleRouteChange() {
      const categoryId = this.$route.query.categoryId;
      if (categoryId) {
        this.selectTab(parseInt(categoryId));
      }
    }
  },
  watch: {
    '$route.query': {
      handler() {
        this.handleRouteChange();
      },
      deep: true
    }
  },
  mounted() {
    this.productInfo = [
      { categoryEnName: '电磁流量计转换器', categoryId: 4 }, 
      { categoryEnName: '智控仪表数据云平台', categoryId: 2 },
      { categoryEnName: '慧光路灯智能云平台', categoryId: 1 }, 
      { categoryEnName: '传统行业物联网改造升级', categoryId: 3 }
    ];
    let initActiveTab = this.$route.query.categoryId ? this.$route.query.categoryId : this.productInfo[0].categoryId;
    this.selectTab(parseInt(initActiveTab));
  },
  updated() {

  }
}
</script>

<style scoped>
.m-products-view {
  background: var(--bg);
}

.m-products-hero {
  position: relative;
  min-height: 240px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
}

.m-products-hero__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.m-products-hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.72) 70%, var(--bg) 100%);
}

.m-products-hero__content {
  position: relative;
  z-index: 1;
  padding: 0 20px 28px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.m-products-hero__title {
  font-family: var(--font-display);
  font-size: 32px;
  font-weight: 700;
  margin: 0;
  color: #fff;
}

.m-products-hero__content .km-eyebrow {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.10);
}

.tabs {
  display: flex;
  justify-content: flex-start;
  overflow-x: auto;
  white-space: nowrap;
  gap: 10px;
  margin-top: 24px;
  padding: 4px 16px 8px;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.tabs::-webkit-scrollbar {
  display: none;
}

.tab {
  flex-shrink: 0;
  padding: 10px 20px;
  border: 1px solid var(--border);
  border-radius: 999px;
  font-family: var(--font-display);
  font-size: 14px;
  color: var(--text-soft);
  background: rgba(255, 255, 255, 0.02);
  transition: all 0.25s ease;
}

.tab.active {
  background: #ffffff;
  color: #08090c;
  border-color: #ffffff;
}

.tab-content {
  padding: 30px 10%;
  border: none;

  .product-container {
    padding: 30px 0px;
    border-bottom: 2px #b9c7ff solid;
    display: flex;
  }

  .product-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 100px;
    /* 图片和名称之间的间距 */
  }

  .product-item {
    width: calc(33.333% - 100px);
    box-sizing: border-box;
    text-align: center;
    border: #ffffff 2px solid;
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    /* 鼠标悬停时的边框阴影 */
    overflow: hidden;
    /* 防止放大的图片溢出容器 */

  }

  .product-image {

    width: 100%;
    height: auto;
    object-fit: cover;
    transition: transform 0.3s ease;
    /* 添加平滑的过渡效果 */
  }

  .product-item:hover .product-image {
    transform: scale(1.1);
    /* 鼠标悬停时放大图片 */
  }

  .product-item:hover .product-name {
    background-color: #e9e9e9;
    color: #94c9f2;
  }

  .product-item:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
    /* 鼠标悬停时的边框阴影 */
  }

  .product-name {
    font-size: 20px;
    background-color: #94c9f2;
    color: white;
    padding-top: 30px;
    height: 60px;
    font-family: math;
  }

}

.details-button {
  padding: 8px 40px;
  color: #fff;
  font-size: 20px;
  border-radius: 20px;
  background-color: #87a8ff;
  border: 2px #ffffff solid;
  cursor: pointer;

  &:hover {
    background-color: #ffffff;
    border: 2px #87a8ff solid;
    color: #87a8ff;
  }
}
</style>
